import { domLoader } from '@/loader.js';

// هدر دیگر position:fixed نیست و با اسکرول از صفحه بیرون می‌رود، پس نه
// لیسنر اسکرول لازم است و نه حالت is-floating. تنها کاری که اینجا مانده
// همگام نگه داشتن --header-height است، چون #main-content و
// scroll-margin-top لنگرها از آن استفاده می‌کنند.
//
// نوشتن یک custom property روی documentElement کل درخت را invalidate
// می‌کند، پس فقط وقتی مقدار واقعاً عوض شده می‌نویسیم. این کار حلقهٔ
// ResizeObserver را هم می‌شکند، چون ارتفاع .site-header__inner خودش از
// همین متغیر می‌آید.
let lastWrittenHeight = -1;
let resizeListener = null;
let resizeObserver = null;

function syncHeaderHeight() {
  const header = document.getElementById('site-header');
  if (!header) {
    return;
  }

  const height = Math.ceil(header.getBoundingClientRect().height);
  if (height === lastWrittenHeight) {
    return;
  }

  lastWrittenHeight = height;
  document.documentElement.style.setProperty('--header-height', `${height}px`);
  // legacy alias — older CSS/JS still reference --site-header-height
  document.documentElement.style.setProperty('--site-header-height', `${height}px`);
}

function unbindHeaderScroll() {
  if (resizeListener) {
    window.removeEventListener('resize', resizeListener);
    resizeListener = null;
  }

  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = null;
  }
}

function bindHeaderScroll() {
  const header = document.getElementById('site-header');
  if (!header) {
    return;
  }

  if (header.dataset.scrollBound === '1') {
    return;
  }

  header.dataset.scrollBound = '1';
  window.headerScrollLoaded = true;

  // اگر قبلا روی یک هدرِ قدیمی (قبل از wire:navigate) بایند شده بودیم،
  // آن لیسنر و observer را رها می‌کنیم تا روی هم انباشته نشوند.
  unbindHeaderScroll();

  syncHeaderHeight();

  resizeListener = syncHeaderHeight;
  window.addEventListener('resize', resizeListener, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(syncHeaderHeight);
    resizeObserver.observe(header);
  }
}

domLoader(function () {
  if (window.headerScrollLoaded) {
    syncHeaderHeight();
    return;
  }
  bindHeaderScroll();
});

document.addEventListener('livewire:navigated', function () {
  window.headerScrollLoaded = false;
  const header = document.getElementById('site-header');
  if (header) {
    header.dataset.scrollBound = '0';
  }
  // هدر جدید ممکن است ارتفاع یکسانی داشته باشد ولی متغیر روی :root با
  // ناوبری پاک می‌شود، پس کش را ریست می‌کنیم تا دوباره نوشته شود.
  lastWrittenHeight = -1;
  bindHeaderScroll();
});

export { syncHeaderHeight };
